<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

import Footer from "@/layouts/Footer.vue";
//COMPONENTS
import ReactionButton from "@/components/ReactionButton.vue";
import SecondaryButton from "@/components/SecondaryButton.vue";
import {reactNotification} from '../../api/notifications/get'

export default {
	props: {
		isTour: {
			required: false,
			type: Boolean,
		},
	},
	components: {
		SecondaryButton,
		Footer,
		ReactionButton
	},
	data() {
		return {
			messages: {
				vote: [],
				reaction: []
			},
			modal: {
				title: null,
				work_position: null,
				message: null,
				comment: null,
				showComment: false,
				show: false,
				gone: false,
				reaction: null,
				type: '',
				original: null
			},
			modalReaction: {
				show: false,
				gone: false,
			},
			modalMore: {
				show: false,
				gone: false,
			},
			selectedReaction: null,
			selectedNotification: null,
			comment: ''
		};
	},
	async created() {
		this.setLoading(false);
		
	},
	computed: {
		...mapGetters({
			readNotifications: "getNotifications/readNotifications",
			//ERRORS
			readNotificationsError: "getNotifications/readError",
			readHasReadError: "hasReadNotification/readError",
			readReactions: "getReactions/readReactions",
			readUser:  'auth/readUser',
			readToken: 'loginStore/readToken',
			readCountVote: "getNotifications/readCountVote",
			readCountReaction: "getNotifications/readCountReaction",
		}),
	},
	methods: {
		...mapMutations({
			//LOADING
			setLoading: "loading/SET_LOADING",
			setNotificationsId: "getNotifications/SET_ID",
			setHasReadId: "hasReadNotification/SET_ID",
			//ERRORS
			setNotificationsError: "getNotifications/SET_ERROR",
			setHasReadError: "hasReadNotification/SET_ERROR",
		}),
		...mapActions({
			setHasRead: "hasReadNotification/hasRead",
			getNotifications: "getNotifications/getNotifications",
			getReactions: 'getReactions/getReactions'
		}),
		toggleModal() {
			this.modal.show = !this.modal.show;
		},
		getImage(image) {
			return `${require(`@/assets/images/views/VOTACION/INICIO/${image}`)}`;
		},
		selectMessage(message) {
			if (message?.is_unread) {
				this.modal.title = message?.title;
				this.modal.work_position = message?.emitter.work_position;
				this.modal.message = message?.content;
				this.modal.showComment= false
				this.modal.comment = message?.comment;
				this.modal.type = message?.type
				this.modal.reaction = this.readReactions.find(r => r.id == message.reaction_id)
				this.modal.original = message
				this.toggleModal();
				// this.markRead(key)
			}
		},
		markRead(key) {
			this.cleanErrors();
			this.setHasReadId(this.messages[key]?.id);
			this.setHasRead();
		},
		
		loadMessages(loading = true, params = {type: 'vote'}) {
			let vm = this
			vm.setLoading(loading);
			vm.cleanErrors();
			vm.setNotificationsId(null);
			vm.getNotifications(params)
				.then((result) => {
					if (result) {
						// this.loadEmitters(this.readNotifications);
						vm.$set(vm.messages, params.type, vm.readNotifications(params.type))
						let votes = vm.readNotifications(params.type)
						console.log(votes)
						let message = votes.items.find(n => n.is_unread)
						vm.selectMessage(message);
					} else {
						vm.messages[params.type] = [];
					}
				})
				.finally(() => {
					vm.setLoading(false);
				});
		},
		begin() {
			return !this.isTour ? this.$router.push({ name: "Reconocer" }) : null;
		},
		getReactionImage(image) {
			return `${require(`@/assets/images/components/reactions/${image}`)}`;
		},
		cleanErrors() {
			this.setHasReadError(null);
			this.setNotificationsError(null);
		},
		hideModal(modal = 'modal') {
			this[modal].gone = true;
			this[modal].show = false;
		},
		showComment() {
			if (this.modal.comment) this.modal.showComment = true;
		},
		hideComment() {
			this.modal.showComment = false;
		},
		emitReaction(reaction, notification) {

			this.selectedReaction = reaction
			this.selectedNotification = notification
			if(notification.emitter_id != this.readUser.id) {
				if (notification.is_unread) {
					this.setHasReadId(notification.id);
					this.setHasRead()
				}
			}
			this.showModal('modalReaction')
		},
		async submitReaction() {
			this.setLoading(true);
			try {
				// this.modal.showComment = false
				this.selectedNotification.reaction_id = this.selectedReaction.id
				let result = await reactNotification(this.readToken, {parent_id: this.selectedNotification.id, reaction_id: this.selectedReaction.id, comment: this.comment})
				this.modal.original.reaction_id = this.selectedReaction.id
				this.selectedNotification = {}
				this.selectedReaction = {}
				this.comment = ''
				this.setLoading(false);
				this.hideModal('modalReaction')
				this.hideModal('modal')
				if(this.readCountVote > 1) {
					this.showModal('modalMore')
				}
			} catch (error) {
			}
			// this.loadMessages( true, {type: 'vote'})
		},
		showModal(modal = "modal") {
			this[modal].gone = false;
			this[modal].show = true;
		},
		
		
	},
};
</script>
<template>
	<div class="relative h-full flex flex-col justify-center items-center">
		
		
		
		<div
			class="relative flex flex-col overlay bg-white mx-auto mt-auto mb-2"
		>
			<img
				class="image mb-auto mx-auto"
				:src="getImage('home_img.png')"
				alt="Trofeo"
			/>
			<p class="px-5 text-center text-3xl mb-3 leading-8 cmf-title">
				<span class="b">Archivos estaticos</span> <br>
				<span class="b elektra-red">Academia de Momentos felices</span>
			</p>
			
			<div class="mt-auto text-center">
				<Footer class="mt-auto static"></Footer>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.overlay {
	height: 85vh;
	max-height: 640px;
}
.image {
	height: 45vh;
	margin-top: -25%;
}
.animtae-smile{
	animation: smileIn .4s forwards ease-in-out;
	animation-delay: 0.4s;
	opacity: 0;
}

@keyframes smileIn{
  0%{
    opacity: 0;
    transform: scale(0.3) translate3d(0,0,0);
  }
  50%{
    opacity: 0.9;
    transform: scale(1.1);
  }
  80%{
    opacity: 1;
    transform: scale(0.89);
  }
  100%{
    opacity: 1;
    transform: scale(1) translate3d(0,0,0);
  }
}
@keyframes go-in {
	0% {
		transform: translateX(100vw);
	}
	100% {
		transform: translateX(0vw);
	}
}

@keyframes go-out {
	0% {
		transform: translateX(0vw);
	}
	100% {
		transform: translateX(-100vw);
	}
}
.modal-base {
	opacity: 0;
	transform: translateX(100vw);
	background: none;
}
.modal-active {
	opacity: 1;
	animation: go-in 0.4s;
	transform: translateX(0vw);
}
.modal-out {
	opacity: 1;
	animation: go-out 0.4s;
	transform: translateX(-100vw);
}
.top-n1{
	top: -1.5rem;
}
.modal-wrap {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: rgba($color: #4a6c85, $alpha: 0.5);
	z-index: 10000000;
}
.whitespace-nowrap{
	white-space: nowrap;
}
.text-slate-400	{
	color: #60686e;
}
</style>
